import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'nest-segment-item',
  styleUrl: 'nest-segment-item.scss',
  shadow: true,
})
export class NestSegmentItem {
  @Prop() label: string;
  @Prop() icon: string;

  /*
  * Controls whether the segmented control item is checked or not.
  */
  @Prop() checked: boolean = false;

  render() {
    const {label, icon, checked} = this;
    return (
      <Host>
        <button
          type="button"
          role="tab"
          data-state={checked ? 'active': 'inactive'}
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow text-zinc-600 dark:text-zinc-200"
          tabindex="-1"
          data-orientation="horizontal"
        >
          {icon && (
            <nest-icon name={icon} class='w-5 h-5 mr-2'></nest-icon>
          )}
          <div>{label}</div>
        </button>
      </Host>
    );
  }
}
